<template>
  <component
    :is="dialogComponent"
    v-model="bottomSheetFlag"
    :content-class="`ui-dialog !wd-max-h-80vh <sm:(!wd-w-full !wd-max-h-[calc(100vh_-_24px)]) ${contentClass}`"
    :width="modalWidth"
    :max-width="maxWidth"
    :persistent="forcing"
    :hide-overlay="hideOverlay"
    scrollable
    @after-leave="onLeave"
    @after-enter="onEnter"
  >
    <v-card class="dialog-container">
      <v-card-title>
        <div
          class="wd-relative wd-w-full wd-flex wd-justify-between wd-items-center !wd-pt-5 !wd-pr-3 !wd-pb-2 wd-pl-1 <sm:(wd-justify-center !wd-py-4 !wd-px-3)"
        >
          <span class="wd-font-medium wd-text-otempmd wd-truncate">{{ headerTitle }}</span>
          <v-btn v-if="closeIcon" class="!wd-absolute wd-right-1" :min-width="40" :width="40" :height="40" variant="text" @click="doCloseIcon">
            <funnow-icon class="wd-w-6 wd-h-6" max-width="24" height="24" image-path="cancel-icon_black.svg" />
          </v-btn>
        </div>
      </v-card-title>

      <v-sheet id="uiModalSheet" class="dialog-container__wrapper wd-overflow-x-hidden" width="100%">
        <slot />
      </v-sheet>

      <slot name="buttons" />
    </v-card>
  </component>
</template>

<script>
import { syncRefs } from '@vueuse/core'

import { useBreakpoints } from '@/composition/useBreakpoints'
import tools from '@/mixin/tools'

import FunnowIcon from '@/components/icons/funnow-icon.vue'

export default defineComponent({
  name: 'UiModal',
  components: {
    FunnowIcon,
  },
  mixins: [tools],
  props: {
    modelValue: { type: Boolean, default: false },
    contentClass: { type: String, default: 'setting-dialog' },
    forcing: { type: Boolean, default: false },
    modalWidth: { type: [Number, String], default: 440 },
    maxWidth: { type: [Number, String], default: 'auto' },
    headerTitle: { type: String, default: '' },
    hideOverlay: { type: Boolean, default: true },
    closeModal: { type: Function, default: null },
    closeIcon: { type: Boolean, default: true },
  },
  emits: ['input', 'closeIconEvent', 'update:modelValue', 'afterLeave', 'afterEnter'],
  setup(props, ctx) {
    const bottomSheetFlag = ref(props.modelValue)
    syncRefs(() => props.modelValue, bottomSheetFlag)

    const { dialogComponent } = useBottomSheetComponent()

    function onLeave() {
      ctx.emit('afterLeave')
    }

    function onEnter() {
      ctx.emit('afterEnter')
    }

    return {
      bottomSheetFlag,
      dialogComponent,
      onLeave,
      onEnter,
    }
  },
  data() {
    return {
      modalData: {},
    }
  },
  computed: {
    modalClass() {
      const className = {}
      className[this.modalSize] = true
      return className
    },
    dialogState: {
      get() {
        // useless now, waiting that all components that using this modal with refactoring with the props `value`
        return this.modelValue
      },
      set(newState) {
        this.bottomSheetFlag = newState
        this.$emit('update:modelValue', newState)
      },
    },
  },
  methods: {
    setModalData(data) {
      this.modalData = data
      return this
    },
    getModalData() {
      return this.modalData
    },
    doCloseIcon() {
      this.$emit('input', false)
      this.$emit('closeIconEvent')
      this.hideModal()
    },
    showModal() {
      this.dialogState = true
    },
    hideModal() {
      this.dialogState = false
    },
  },
})
</script>

<style lang="scss" scoped>
.dialog-container {
  overflow-y: hidden !important;
  .v-card__title {
    p {
      margin: 0;
    }
  }

  &__wrapper {
    flex: 1;
    overflow-y: auto;
  }
}
</style>
<style lang="scss">
/* TODO: global style should not be here */
.v-dialog.ui-dialog {
  width: auto;
  align-self: center !important;

  @include xxs {
    width: 100%;
    align-self: flex-end !important;
  }
}

.v-dialog.ui-dialog.ui-dialog--flex > .dialog-container {
  @apply wd-max-h-full wd-flex wd-flex-col;
}

.dialog-container {
  border-radius: 4px;

  @include xxs {
    border-radius: 0 !important;
    border-top-left-radius: 12px !important;
    border-top-right-radius: 12px !important;
  }
}
.empty-hint {
  text-align: center;
  font-size: $baseFontSize;
  color: $gray80;
  position: absolute;
  text-align: center;
  width: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
